/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Pending_PaymentInputs */

const en_status_pending_payment = /** @type {(inputs: Status_Pending_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Payment`)
};

const es_status_pending_payment = /** @type {(inputs: Status_Pending_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago pendiente`)
};

/**
* | output |
* | --- |
* | "Pending Payment" |
*
* @param {Status_Pending_PaymentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_pending_payment = /** @type {((inputs?: Status_Pending_PaymentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Pending_PaymentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_pending_payment(inputs)
	return es_status_pending_payment(inputs)
});